import React from "react";
import { withStyles } from "@material-ui/core/styles";
import SwitchWithLabel from "../../../common/CustomSwitch";
import CustomTextField from "../../../common/CustomTextField";
import Collapse from "@material-ui/core/Collapse";
import { MAX_VALUE_CONSTRAINTS, MIN_VALUE } from "../../../common/constants";
const styles = (theme) => ({
  flexRow: {
    display: "flex",
    direction: "column",
    "&>div": {
      flex: 1,
      width: "100%",
    },
  },
  shrinkWrapInput: { width: "35%" },
  shrinkWrapInfo: {
    color: theme.TextColor,
    fontSize: theme.textFontSize,
    opacity: 0.8,
  },
});

const ShrinkWrap = ({ classes, errorInfo, editInfo, handleChange }) => {
  const handlePalletCount = (value) => {
    handleChange("palletCount")(value);
  };
  return (
    <>
      <SwitchWithLabel
        rowLabel="Shrink wrap intact"
        onChange={handleChange("isShrinkWrap")}
        value={editInfo.isShrinkWrap}
      />
      <span className={classes.shrinkWrapInfo}>
        Enter no. of shrink wrap intact accepted pallets
      </span>
      <Collapse in={editInfo.isShrinkWrap} timeout="auto" unmountOnExit>
        <CustomTextField
          id="shrinkWrap"
          label="Pallet Count"
          handleChange={handlePalletCount}
          error={errorInfo.palletCount}
          value={editInfo.palletCount}
          className={classes.shrinkWrapInput}
          type="number"
          inputProps={{
            max: MAX_VALUE_CONSTRAINTS.DELIVERY_PRO_FORM.PALLET_COUNT,
            focused: true,
            min: MIN_VALUE.DEFAULT,
          }}
        />
      </Collapse>
    </>
  );
};

export default withStyles(styles)(ShrinkWrap);
